/**
 * Moduł do sterowania sliderem w sekcji RATY -> Dobre Raty, na karcie produktu.
 */
app.service('productTabInstalments',function(console, productCardConfig, cartManager, modal, callback, front, operatorMaxInstalment, productCardTest, stackedModal) {
	var $self, $body, $tabs, $customOptions, $slider, $thumb, $addCAInstalment, $addEuroInstalment;
	var currentTab = 0;
	var $instalment;
	var instalmentCode = '';
	var instalmentDuration = 0;
	var warranty;
	var sliderWidth, sliderLength, rangeMin, rangeMax, rangeStep;
	var config;

	function addCAInstalment(paymentType, outletCategoryId) {
		addInstalment(paymentType, 'HOME', outletCategoryId);
	}
	function addMainInstalment(paymentType, outletCategoryId) {
		addInstalment(paymentType, 'SHOP', outletCategoryId);
	}
	function addInstalment(paymentType, type, outletCategoryId){

		var clientMaxInstalmentWorth = operatorMaxInstalment.getData();
		var plu = config.plu;
		var addedFrom = 'PRODUCT_CARD';
		var warrantyAddedFrom = 'PRODUCT_CARD_INSTALLMENT_WITH_WARRANTY';

		modal.close();
		operatorMaxInstalment.clear();
		cartManager.addToCartFromInstalment(config.id, instalmentCode, instalmentDuration, paymentType, type, addedFrom, plu, clientMaxInstalmentWorth, outletCategoryId, warranty, warrantyAddedFrom);
	}

	function getSelectedInstalmentData() {
		return {
			code: instalmentCode,
			number: instalmentDuration
		};
	}

	function timeFormat(time){
		if(time==1) {
			return '1 rata';
		} else if(time%10>1 && time%10<5) {
			return time + ' raty';
		} else {
			return time + ' rat';
		}
	}
	function startSlider(event) {
		sliderWidth = $slider.width();
		updateSlider(event);
		$body.on('mousemove touchmove', updateSlider);
		$body.on('mouseup touchend mouseleave touchleave', stopSlider);
	}
	function updateSlider(event) {
		var x = event.clientX - $slider.offset().left;
		var y = event.clientY - $slider.offset().top;
		var duration = (Math.max(Math.min(Math.ceil((x / sliderWidth) * sliderLength),sliderLength),1) - 1) * rangeStep + rangeMin;
		if (duration != instalmentDuration) {
			repaintSlider(duration);
		}
	}
	function repaintSlider(duration) {
		var $tab=$('.instalment-option[data-instalment='+currentTab+']');
		$slider = $('.js-instalment-customable', $tab);
		$thumb = $('.js-instalment-thumb', $slider);
		var $units =  $('.js-range-unit', $slider);
		sliderLength = $units.length;
		var $pricing = $('.js-instalment-pricing', $tab);
		rangeMin = Math.max($pricing.first().data('option')/1, 1);
		rangeMax = Math.max($pricing.last().data('option')/1, 1);
		rangeStep = Math.max((rangeMax - rangeMin)/(sliderLength-1), 1);

		if(duration){
			duration = Math.min(rangeMax, duration);
			duration = Math.max(rangeMin, duration);
			var position = (duration - rangeMin)/rangeStep + 1 ;
			//console.log(position, rangeMin, rangeMax, rangeStep)
			if(position){

				instalmentDuration = duration;

				var $unit = $('.js-range-unit:nth-child('+position+')', $tab);
				$unit.prevAll().addClass('active');
				$unit.addClass('active');
				$unit.nextAll().removeClass('active');

				var $promotionPackage = $('.promotions-package-item[data-code="' + instalmentCode +'"]', $self);
				$promotionPackage.removeClass('promotions-package-item-visible')
				$promotionPackage.filter('[data-duration="' + duration + '"]').addClass('promotions-package-item-visible');

				var $pricing = $('.js-instalment-pricing[data-option=' + duration + ']');
				$pricing.prevAll().removeClass('selected-pricing');
				$pricing.addClass('selected-pricing');
				$pricing.nextAll().removeClass('selected-pricing');

				$thumb.text(timeFormat(duration));
				$unit.append($thumb);

				operatorMaxInstalment.prepare(instalmentDuration);
			}
		}
	}

	function stopSlider(event) {
		$body.off('mousemove touchmove', updateSlider);
		$body.off('mouseup touchend mouseleave touchleave', stopSlider);
	}
	function openInstalmentsTab(props) {
		const initInstalmentDuration = parseInt(props && props.number);
		const initInstalmentCode = props && props.code;
		var tab = $instalment.data('instalment');

		instalmentCode = initInstalmentCode || $instalment.data('code');
		instalmentDuration = initInstalmentDuration || $instalment.data('duration');
		warranty = $instalment.data('warranty');

		$self.removeClass('show-tab-' + currentTab);
		$self.addClass('show-tab-' + tab);
		currentTab = tab;
		repaintSlider(instalmentDuration);
	}
	function reload({ productId, outletCategoryId }) {
		return $.ajax({
			url: '/product-card-instalment.ltr',
			data: {
				productId,
				outletCategoryId
			}
		}).then(html => {
			$self.html(html);
			init();
		}).fail(() => modal.alert('Błąd pobierania zakładki rat.'));
	}
	function setEvents(){
		$self.on('click', '.js-preview-warranty-details', function handlePreviewWarrantyDetailsClick() {
			const id = $(this).data('index');
			stackedModal.push(modal.open(`preview-warranty-${id}`));
		});
		$tabs.on('click', function() {
			$instalment = $(this);
			openInstalmentsTab();
			if(instalmentCode === 'Dobre raty') {
				UA.interaction('KP_Crossell', 'Raty_modal_zakladki', instalmentCode.split(' ').join('_'));
			} else {
				UA.interaction('KP_Crossell', 'Raty_modal_zakladki', `Raty_do_${warranty > 0 ? `${instalmentCode}_z_ochrona_sprzetu` : instalmentCode}`);
			}
		});
		$slider.on('mousedown touchstart', function(event) {
			startSlider(event);
		});
		$slider.on('dragstart', function(event) {
			event.preventDefault();
		});
		if (!productCardTest.enabled) {
			$addCAInstalment.on('click', function() {
				addCAInstalment($(this).data('payment'), $(this).data('outlet-category-id'));
			});
			$addMainInstalment.on('click', function() {
				addMainInstalment($(this).data('payment'), $(this).data('outlet-category-id'));
			});
		}
		$('.js-instalment-popup', $self).click(function(){
			stackedModal.push(modal.open('instalment-'+$(this).data('modal')));
		});
		$('.js-ca-instalment-info', $self).click(function(){
			UA.interaction('KP', 'Raty', 'Więcej o Ratach przez Internet');
			stackedModal.push(modal.open('instalment-ca'));
		});
		$('.js-main-instalment-info', $self).click(function(){
			UA.interaction('KP', 'Raty', 'Więcej o Ratach z Doradcą');
			stackedModal.push(modal.open('instalment-main'));
		});
		$('.js-check-instalment-ca',$self).click(function(){
			stackedModal.push(modal.open('instalment-ca'));
		});
		$('.js-check-instalment-main',$self).click(function(){
			stackedModal.push(modal.open('instalment-main'));
		});
	}
	function setElements(props) {
		$self = $('#installments');
		$body = $('body');
		$tabs = $('.js-tab', $self);
		$slider = $('.js-instalment-customable', $self);
		$addCAInstalment = $('.js-add-ca-instalment', $self);
		$addMainInstalment = $('.js-add-main-instalment', $self);
		setActiveTab(props);

		config = productCardConfig.getData();
	}

	function setActiveTab(props) {
		if(props && props.code) {
			$tabs.each(index => {
				let itemCode = $($tabs[index]).data('code').toString();
				let itemWarranty = $($tabs[index]).data('warranty').toString();
				let propsCode = props.code.toString();
				let propsWarranty = props.warrantyId ? props.warrantyId.toString() : "";
				if (itemCode === propsCode && itemWarranty === propsWarranty) {
					$instalment = $($tabs[index]);
				}
			});
		} else {
			$instalment = $($tabs[0]);
		}
	}

	function init(props){
		setElements(props);
		setEvents();
		operatorMaxInstalment.init();
		openInstalmentsTab(props);
	}
	return {
		init:init,
		reload: reload,
		getData: getSelectedInstalmentData
	};
});
